import React from 'react'

const URGENCY_LEVELS = [
  {
    key: 'emergency',
    label: 'Emergency',
    description: 'Poses an immediate threat to safety or property (e.g., fire, major flood).',
    badge: { background: '#F44336', color: '#fff', border: '#F44336' },
  },
  {
    key: 'high',
    label: 'High',
    description: 'Impacts essential living (e.g., a non-functional appliance, no hot water).',
    badge: { background: 'transparent', color: '#FF9800', border: '#FF9800' },
  },
  {
    key: 'medium',
    label: 'Medium',
    description: 'Needs attention soon but is not a critical hazard (e.g., dripping faucet).',
    badge: { background: 'transparent', color: '#2196F3', border: '#2196F3' },
  },
  {
    key: 'low',
    label: 'Low',
    description: 'Cosmetic or minor issue (e.g., a scratch on the wall, a loose cabinet knob).',
    badge: { background: 'transparent', color: '#4CAF50', border: '#4CAF50' },
  },
]

interface UrgencyStepProps {
  value: string
  onChange: (value: string) => void
}

const UrgencyStep = ({ value, onChange }: UrgencyStepProps) => (
  <div>
    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>How urgent is the issue?</h3>
    <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: '0 0 24px' }}>Select the urgency level that best describes the situation.</p>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {URGENCY_LEVELS.map((level) => {
        const selected = value === level.key
        return (
          <button
            key={level.key}
            type="button"
            onClick={() => onChange(level.key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '18px 24px',
              borderRadius: '12px',
              border: `2px solid ${selected ? '#2196F3' : '#e5e7eb'}`,
              backgroundColor: selected ? '#EFF6FF' : '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              width: '100%',
              transition: 'border-color 0.15s, background-color 0.15s',
            }}
          >
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '3px 10px',
              borderRadius: '4px',
              border: `1.5px solid ${level.badge.border}`,
              backgroundColor: level.badge.background,
              color: level.badge.color,
              fontSize: '0.8125rem',
              fontWeight: 600,
              flexShrink: 0,
              minWidth: '90px',
            }}>
              {level.label}
            </span>
            <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280' }}>
              {level.description}
            </p>
          </button>
        )
      })}
    </div>
  </div>
)

export default UrgencyStep
